import Layout from './Layout'
import { Button, Container, makeStyles, Paper, Typography } from '@material-ui/core'
import DescriptionIcon from '@material-ui/icons/Description';
import { useEffect, useState } from 'react';
import axios from 'axios'
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: "30px"
    },
    title: {
        fontWeight: 600
    },
    submit: {
        marginTop: theme.spacing(2),
        textTransform: "none",
        borderRadius: 0,
        fontSize: "14px",
        backgroundColor: "#d8dbe4",
        "&:hover": {
            backgroundColor: "#f2f3f7"
        }
    },
}));

const Statement = () => {
    const history = useHistory()
    const classes = useStyles();
    const [link, setLink] = useState('/')

    useEffect(() => {
        axios.get('/api/pdf', { withCredentials: true })
            .then(({ data }) => {
                if (!data.pathToPdf) {
                    return history.push('/')
                }

                setLink(data.pathToPdf)
            })
    }, [])

    return <Layout>
        {link && <Container maxWidth="xs">
            <Paper elevation={0} className={classes.paper}>
                <Typography variant="h6" className={classes.title}>
                    Скачать заявление
                </Typography>
                <Button
                    href={link}
                    className={classes.submit} variant="contained" disableElevation
                    startIcon={<DescriptionIcon />}
                >Скачать</Button>
            </Paper>
        </Container>}
    </Layout>
}

export default Statement